module.exports = "//public.getcloudapp.com/packs/media/images/adobe-db2727c13b24b1f01030167274c83b9f.png";